import Client from "./Client";
// import RequestList from "./RequestList";

const FaxesService = {
    url: 'admin/subscription-classes',
    getDefault(){
        return {
            id: undefined,
            name: undefined,
            caption: undefined,
            limitation_send: undefined,
            validity_duration: undefined,
            tax_rate: undefined,
            price: undefined,
            user_selectable: undefined,
            created_at: undefined,
            updated_at: undefined,
            disabled_at: undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList ? requestList.json() : null);
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async create(subscriptionClass) {
        return await Client.post(`${this.url}`, subscriptionClass);
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async update(subscriptionClass) {
        return await Client.post(`${this.url}/${subscriptionClass.id}`, subscriptionClass);
    }
}

export default FaxesService